var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.4167L17.25 8.25M17.25 8.25L12.6667 4.08333M17.25 8.25H6.25M6.25 15.75H2.58333C2.0971 15.75 1.63079 15.5744 1.28697 15.2618C0.943154 14.9493 0.75 14.5254 0.75 14.0833V2.41667C0.75 1.97464 0.943154 1.55072 1.28697 1.23816C1.63079 0.925595 2.0971 0.75 2.58333 0.75H6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.84abb32eaadd0bee26cb5f4eb5e86800.svg";
export { ForwardRef as ReactComponent };